var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "remove-modal",
        role: "dialog",
        tabindex: "-1",
        "aria-hidden": "true"
      }
    },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "modal-body" },
            [
              _c("p", [_vm._v("Does you remove this post?")]),
              _vm.vm
                ? _c("post", { attrs: { data: _vm.vm.post, "view-only": "" } })
                : _vm._e()
            ],
            1
          ),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                ref: "cancelButton",
                staticClass: "btn btn-secondary",
                attrs: {
                  type: "button",
                  tabindex: "1",
                  "data-dismiss": "modal"
                }
              },
              [_vm._v("Cancel")]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { tabindex: "2", "data-dismiss": "modal" },
                on: { click: _vm.ok }
              },
              [_vm._v("OK")]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [
        _vm._v("\n          Remove post?\n        ")
      ]),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-93b20c04", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93b20c04","hasScoped":false,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./components/RemoveModal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-93b20c04","hasScoped":false,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./components/RemoveModal.vue
// module chunks = 0